import React from 'react';
import { useChartContainerContext } from '../ChartContainer';
import { useChartInteractionDispatch, useChartInteractionState } from '../ChartInteractionProvider';
import { useChartSurfaceContext } from '../ChartSurface';
import { useChartTooltipContext } from './ChartTooltipProvider';

export const usePinnedDismissal = () => {
  const { isPinned } = useChartInteractionState();
  const { setHighlight } = useChartInteractionDispatch();
  const { reset, tooltipRef } = useChartTooltipContext();
  const { surfaceRef } = useChartSurfaceContext();
  const { containerRef } = useChartContainerContext();

  const dismiss = React.useCallback(() => {
    reset();
    setHighlight(null);
  }, [reset, setHighlight]);

  React.useEffect(() => {
    if (!isPinned) return () => {};

    const abortController = new AbortController();

    const handleTooltipPointerLeave = (e: PointerEvent) => {
      if (e.relatedTarget instanceof SVGElement) {
        if (e.relatedTarget === surfaceRef.current || e.relatedTarget.ownerSVGElement === surfaceRef.current) {
          return;
        }
      }
      dismiss();
    };

    const handleContainerPointerLeave = (e: PointerEvent) => {
      if (e.relatedTarget instanceof HTMLElement) {
        if (e.relatedTarget === tooltipRef.current || e.relatedTarget.offsetParent === tooltipRef.current) {
          tooltipRef.current?.addEventListener('pointerleave', handleTooltipPointerLeave, { signal: abortController.signal });
          return;
        }
      }
      dismiss();
    };

    containerRef.current?.addEventListener('pointerleave', handleContainerPointerLeave, { signal: abortController.signal });

    return () => {
      abortController.abort();
    };
  }, [dismiss, surfaceRef, tooltipRef, containerRef, isPinned]);
};
